import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
	chartContainer: {
		marginTop: theme.spacing(5),
	},
}));
